import { FlexComponent, FlexVCNode } from "src/typings/flexFramework/FlexComponent";
import { getNameFromFlexComponent } from "src/stores/CompositionStore";

/**
 * creates ViewComposition equivalent of provided FlexComponent
 * @param {FlexComponent} flexComponent
 * @param {boolean} includeDescendants - Default TRUE. If true, all descendants will be converted to IViewComposition objects while populating it's childNodes. If false, childNodes will not be populated
 * @returns IViewComposition
 */
export const flexComponentToViewCompositionNode = (
  flexComponent: FlexComponent,
  includeDescendants: boolean = true
): FlexVCNode => {
  let view = getNameFromFlexComponent(flexComponent);
  const flexComponentView = flexComponent.view ? (flexComponent.view as string) : undefined;

  if (flexComponentView && flexComponentView !== "default") {
    view = `${view}_${flexComponentView}`;
  }

  const fmId = flexComponent.fmId;
  let id = flexComponent.id;

  //TODO: remove when we start getting id's consistently from the composition for all components
  id = !id ? (fmId ? `${view}${fmId}` : `${view}${Math.round(Math.random() * 100000)}`) : id;

  const options = {
    ...flexComponent,
    flexComponentView,
  } as any;

  if (getNameFromFlexComponent(flexComponent) === "tab" || getNameFromFlexComponent(flexComponent) === "region") {
    options.containerName = flexComponent.name;
  }

  delete options.id;
  delete options.name;
  delete options.modules;
  delete options.children;
  delete options.groups;
  delete options.model;

  const viewComposition: FlexVCNode = {
    id,
    view,
    options,
  };

  if ((flexComponent.modules || flexComponent.groups || flexComponent.children) && includeDescendants) {
    //TODO: all children are assumed as array type since this matches Template and Composition structure. How to use map type children via Template or Composition?

    // gather and create decendant BlossomComponents
    const childFlexComponents: FlexComponent[] = [
      ...(flexComponent.modules || []),
      ...(flexComponent.groups || []),
      ...(flexComponent.children || []),
    ];

    const childNodes = childFlexComponents
      .map((child) => flexComponentToViewCompositionNode(child))
      .filter((node) => !!node);

    if (childNodes.length > 0) {
      viewComposition.childNodes = childNodes;
    }
  }

  return viewComposition;
};
